import Image from 'next/legacy/image';

export default function NotionEmbedCode() {
  return (
    <li>
      <h3 id="get-embed-code">Get Embed Code</h3>
      <p>
        Click on the <code>Embed Code</code> button which is at the bottom left of the dashboard,
        and click on <code>Notion</code> tab.
      </p>
      <p>Copy the code (Link) you see there.</p>

      <Image src="/guides/embed-code-notion.png" width={1630} height={1240} alt="embed dialog" />
    </li>
  );
}
